import * as React from "react"

type SidebarState = "expanded" | "collapsed"

type SidebarContextProps = {
  state: SidebarState
  visualState: SidebarState
  open: boolean
  setOpen: (open: boolean) => void
  openMobile: boolean
  setOpenMobile: (open: boolean) => void
  isMobile: boolean
  toggleSidebar: () => void
  hoverExpanded: boolean
  setHoverExpanded: (expanded: boolean) => void
  /** Yalnız yöneticiler için sıkı ölçü + otomatik daralma (yönetici değilse false). */
  compact: boolean
}

export const SidebarContext = React.createContext<SidebarContextProps | null>(
  null,
)

export function useSidebar() {
  const context = React.useContext(SidebarContext)
  if (!context) {
    throw new Error("useSidebar must be used within a SidebarProvider.")
  }
  return context
}

export type { SidebarContextProps, SidebarState }
